// namespace
window.Components = window.Components || {};

(function($) {

    'use strict';

    function multipleFile() {
        var self = this,
            current = 1,
            max = 5,
            $cache = {};

        function addInputTl($item) {
            if($item.hasClass('is-active')) return false;

            var wrapH = $cache.contentWrap.outerHeight();
            var itemH = $item.outerHeight();
            var calcH = wrapH+itemH;

            var tl = new TimelineMax({onStart: function () {
                $cache.moreWrap.addClass('is-hidden');
                $item.addClass('is-active');
            }});

            tl.add(function() {
                if(current < max) {
                    $cache.moreWrap.removeClass('is-hidden');
                }
            }, 0.4);
            tl.fromTo($item, 0.8, {opacity: 0}, {opacity: 1, ease: Quad.easeInOut}, 0.2);
            tl.fromTo($cache.contentWrap, 0.8, {height: wrapH}, {height: calcH, clearProps: 'height', ease: Power2.easeOut}, 0);

            return tl;
        }

        function loadComponent($item) {
            var $components = $item.find("[data-component]");
            $components.each(function(index){
                var $el = $(this);
                var comp = $el.data('component');

                //Check if component exist
                if(typeof window.Components[comp] !== 'function') {
                    return;
                }

                // Component instantiation
                var obj = new window.Components[comp]($el);
                // Store instance in data
                $el.data('comp', obj);
            });
        }

        function addInput() {
            if(current >= max) return false;

            var $clone = $cache.placeholder.clone();
            var $cloneLabel = $clone.find('label');
            var $cloneInput = $clone.find('input');

            current++;

            var id = $cloneInput.attr('id');
            id = id+current;
            $cloneInput.attr('id', id);
            $cloneLabel.attr('for', id);

            $cache.contentWrap.append($clone);
            loadComponent($clone);

            var tl = addInputTl($clone);
            tl.play();
        }

        function onClick(e) {
            e.preventDefault();

            addInput();
        }

        /**
         * Init Cache
         */
        function initCache(target) {
            $cache.html = $('html');
            $cache.main = target;

            $cache.placeholderWrap = $cache.main.find('.input-placeholder');
            $cache.placeholder = $cache.placeholderWrap.find('.input-wrapper');


            $cache.contentWrap = $cache.main.find('.mfu-wrapper');

            $cache.moreWrap = $cache.main.find('.mfu-more');
            $cache.moreCta = $cache.moreWrap.find('.more-file');
        }

        /**
         * Register Events
         */
        function registerEvents() {
            $cache.moreCta.on('click', onClick);
        }

        /**
         * Public constructor
         * @param  {Object} opts Options
         */
        self.initialize = function(target) {
            initCache(target);
            registerEvents();
        };

        self.initialize.apply(self, arguments);
        return self;
    }

  window.Components.multipleFile = multipleFile;

}(jQuery));
